"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ramda = require("ramda");

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SpecsWrapper = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "features-specifications__SpecsWrapper",
  componentId: "sc-1y9ai7x-0"
})(["counter-reset:footnotes;"]);
var FootnoteLabel = (0, _styledComponents["default"])(_primitives["default"].Text).withConfig({
  displayName: "features-specifications__FootnoteLabel",
  componentId: "sc-1y9ai7x-1"
})(["counter-increment:footnotes;&::after{content:counter(footnotes);vertical-align:super;font-size:0.5em;margin-left:2px;}"]);
var propTypes = {
  /** Background color string of Component Containers */
  backgroundColor: _propTypes.string,

  /** Setting for bottom padding amount * */
  bottomUnitPadding: _propTypes.number,

  /** classname of Component Containers */
  className: _propTypes.string,

  /** custom background tag of Component Containers */
  customBackground: _propTypes.string,

  /** darkui boolean of Title Font */
  darkUi: _propTypes.bool,

  /** Features items - an array of strings or react components */
  featuresItems: (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string])),

  /** Features title string */
  featuresTitle: _propTypes.string,

  /** Component Container Html ID string */
  htmlId: _propTypes.string,

  /** Map index */
  index: _propTypes.number,

  /** Footnote item shape */
  item: (0, _propTypes.shape)({
    desc: _propTypes.string,
    footnote: _propTypes.string,
    title: _propTypes.string
  }),

  /** Footnote comma boolean flag */
  showComma: _propTypes.bool,

  /** Spec disclaimer component */
  specsDisclaimer: _propTypes.node,

  /** Specs items object */
  specsItems: (0, _propTypes.shape)({
    footnotes: (0, _propTypes.arrayOf)(_propTypes.string),
    items: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      depth: _propTypes.string,
      desc: (0, _propTypes.arrayOf)(Object),
      footnote: _propTypes.string,
      id: _propTypes.string,
      parent: _propTypes.string,
      title: _propTypes.string
    }))
  }),

  /** Specs title string */
  specsTitle: _propTypes.string,

  /** Theme object */
  theme: _utils.themePropType,

  /** setting for padding amount * */
  topUnitPadding: _propTypes.number
};
var defaultProps = {
  bottomUnitPadding: 2,
  topUnitPadding: 2
};
var titleFont = {
  borderBottom: "1px solid",
  borderBottomColor: "grey",
  fontSize: 8,
  fontWeight: 2,
  lineHeight: 2,
  pb: 3,
  tag: "h2",
  textAlign: "left",
  width: 1
};
var descriptionFont = {
  fontSize: [3, 2, 2, 2, 2],
  fontWeight: 1,
  lineHeight: [1.3, 1.2],
  tag: "p"
};
var preTitleFont = {
  fontSize: [4, 3, 3, 3, 3],
  fontWeight: 2,
  lineHeight: 3,
  tag: "p"
};
var footnotesFont = {
  fontSize: [0],
  lineHeight: [0],
  mb: [".75em"],
  pl: [".5em"]
};

var FeaturesSpecifications = function FeaturesSpecifications(_ref) {
  var backgroundColor = _ref.backgroundColor,
      bottomUnitPadding = _ref.bottomUnitPadding,
      topUnitPadding = _ref.topUnitPadding,
      className = _ref.className,
      customBackground = _ref.customBackground,
      darkUi = _ref.darkUi,
      featuresTitle = _ref.featuresTitle,
      specsTitle = _ref.specsTitle,
      featuresItems = _ref.featuresItems,
      specsItems = _ref.specsItems,
      specsDisclaimer = _ref.specsDisclaimer,
      htmlId = _ref.htmlId,
      theme = _ref.theme;

  var _useMemo = (0, _react.useMemo)(function () {
    return darkUi ? {
      footNotesTextColor: "text-light",
      textColor: "text-light",
      titleTextColor: "text-light"
    } : {
      footNotesTextColor: "text-legal-copy",
      textColor: "text",
      titleTextColor: "text-title"
    };
  }, [darkUi]),
      titleTextColor = _useMemo.titleTextColor,
      textColor = _useMemo.textColor,
      footNotesTextColor = _useMemo.footNotesTextColor;

  var defaultBg = darkUi ? "background-dark" : "background";
  var specifications = (0, _ramda.propOr)([], "items", specsItems);
  var footnotes = (0, _ramda.propOr)([], "footnotes", specsItems);

  var showFootnoteLabel = function showFootnoteLabel(_ref2) {
    var item = _ref2.item,
        index = _ref2.index,
        showComma = _ref2.showComma;
    var comma = showComma ? ", " : "";

    if (!item.footnote) {
      return "" + item.title + comma;
    }

    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(FootnoteLabel, _extends({}, descriptionFont, {
      tag: "span"
    }), item.title), comma);
  };

  var renderSpecs = function renderSpecs(descs) {
    return (0, _utils.mapIndexed)(function (item, index) {
      return showFootnoteLabel({
        index: index,
        item: item,
        showComma: index !== descs.length - 1
      });
    }, descs || []);
  };

  return /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Wrapper, {
    alignItems: "center",
    backgroundColor: backgroundColor || defaultBg,
    className: className,
    htmlId: htmlId,
    justifyContent: "center",
    tag: customBackground
  }, /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Container, {
    justifyContent: "space-between",
    pb: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return bottomUnitPadding * padding;
    }),
    pt: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return topUnitPadding * padding;
    })
  }, featuresItems && featuresItems.length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    alignItems: "flex-start",
    columns: [6, 8, 4],
    flexDirection: "column",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    color: titleTextColor
  }, titleFont), featuresTitle), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    alignItems: "flex-start",
    as: "ul",
    mt: [35, 35, 35, 35, 28],
    pl: 2,
    width: 1
  }, (0, _utils.mapIndexed)(function (feature, index) {
    return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
      key: index,
      as: "li",
      color: textColor,
      display: "list-item",
      mb: 24
    }, descriptionFont), feature);
  }, featuresItems))), /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    columns: [0, 0, 1]
  })), specifications && specifications.length > 0 && /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    alignItems: "flex-start",
    columns: [6, 8, 7],
    flexDirection: "column",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    color: titleTextColor
  }, titleFont), specsTitle), /*#__PURE__*/_react["default"].createElement(SpecsWrapper, {
    flexDirection: "column",
    mt: [35, 35, 35, 35, 28],
    width: [1]
  }, (0, _utils.mapIndexed)(function (spec, index) {
    return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
      key: index,
      alignItems: "baseline",
      borderBottom: ["1px solid", "none"],
      borderBottomColor: ["divider"],
      flexDirection: ["column", "row"],
      justifyContent: "space-between",
      mb: [2, 3]
    }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({}, preTitleFont, {
      color: textColor,
      mb: [1, 0],
      pr: [0, 3],
      width: [1, 0.279]
    }), spec.title), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
      flexDirection: "column",
      mb: [1, 0],
      width: [1, 0.72]
    }, Array.isArray(spec.desc) && (0, _utils.mapIndexed)(function (item, key) {
      return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
        key: key,
        mb: [1, 2]
      }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
        color: textColor
      }, descriptionFont), /*#__PURE__*/_react["default"].createElement("strong", null, item.title + ": "), renderSpecs(item.desc)));
    }, spec.desc)));
  }, specifications))), /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    columns: featuresItems && featuresItems.length ? [6, 8, 12] : [6, 8, 7.2],
    my: [1]
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, {
    as: "ol",
    pl: 2
  }, (0, _utils.mapIndexed)(function (footnote, index) {
    return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
      key: index,
      color: footNotesTextColor,
      tag: "li"
    }, footnotesFont), footnote);
  }, footnotes))), specsDisclaimer && /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Element, {
    columns: featuresItems && featuresItems.length ? [6, 8, 12] : [6, 8, 7.2]
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    color: footNotesTextColor,
    tag: "div"
  }, footnotesFont), specsDisclaimer))));
};

FeaturesSpecifications.defaultProps = defaultProps;
FeaturesSpecifications.propTypes = propTypes;
FeaturesSpecifications.displayName = "Modules.FeaturesSpecifications";

var _default = (0, _styledComponents.withTheme)(FeaturesSpecifications);

exports["default"] = _default;